import api from '@utils/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import customEventBus from '@common/scripts/libs/eventBus';
import bagSlice from './bag.slice';
import { BagActionTypes } from './common.types';
function* handleFetchBag(action) {
    var _a;
    let bag = yield call(api.getFullCart);
    if (!((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.fromMinicart)) {
        // console.info('handleFetchBag - fromMinicart');
        customEventBus.emit('minicart:update', {});
    }
    yield put(bagSlice.actions.updateBag(bag));
}
function* handleAddPromoCode(action) {
    yield put(bagSlice.actions.resetPromoCodeError());
    const data = yield call(api.addPromoCode, action.payload);
    if ((data === null || data === void 0 ? void 0 : data.error) === true) {
        yield put(bagSlice.actions.setPromoCodeError(data.errorMessage));
        return;
    }
    yield handleFetchBag();
}
function* handlePromoCodeRemove(action) {
    yield put(bagSlice.actions.resetPromoCodeError());
    const data = yield call(api.promocodeRemove, action.payload);
    if ((data === null || data === void 0 ? void 0 : data.error) === true) {
        yield put(bagSlice.actions.setPromoCodeError(data.errorMessage));
        return;
    }
    yield handleFetchBag();
}
function* handleSetMessage(action) {
    yield put(bagSlice.actions.setMessage(action.payload));
}
function* handleIncreaseQuantity(action) {
    yield put(bagSlice.actions.startUpdatingQuantity());
    yield call(api.addToBag, action.payload.pid, 1);
    yield handleFetchBag();
    yield put(bagSlice.actions.stopUpdatingQuantity());
}
function* handleDecreaseQuantity(action) {
    yield put(bagSlice.actions.startUpdatingQuantity());
    // This should not work... but it does.
    // TODO: (emi) Create a real API method to decrease cart quantity by one.
    yield call(api.addToBag, action.payload.pid, -1);
    yield handleFetchBag();
    yield put(bagSlice.actions.stopUpdatingQuantity());
}
function* handleRemoveProduct(action) {
    yield call(api.removeFromBag, action.payload.pid, action.payload.uuid);
    yield handleFetchBag();
}
function* watchFetchRequest() {
    yield takeEvery(BagActionTypes.FETCH_BAG, handleFetchBag);
    yield takeEvery(BagActionTypes.REMOVE_PRODUCT_FROM_BAG, handleRemoveProduct);
    yield takeEvery(BagActionTypes.INCREASE_QUANTITY, handleIncreaseQuantity);
    yield takeEvery(BagActionTypes.DECREASE_QUANTITY, handleDecreaseQuantity);
    yield takeEvery(BagActionTypes.ADD_PROMO_CODE, handleAddPromoCode);
    yield takeEvery(BagActionTypes.PROMOCODE_REMOVE, handlePromoCodeRemove);
    yield takeEvery(BagActionTypes.SETMESSAGE, handleSetMessage);
}
export default function* bagSaga() {
    yield all([fork(watchFetchRequest)]);
}
